import { BaseChart } from "./BaseChart";
import { TimePeriod } from "./TimePeriodSelector";
import type { HipSizeResponse } from "@/types/tracker";
import { processSimpleTrackerChartData } from "./utils";
import { getMetricColor } from "./chart-theme";

interface HipChartProps {
  data: HipSizeResponse | null;
  selectedPeriod: TimePeriod;
  currentDate: Date;
}

export const HipChart = ({
  data,
  selectedPeriod,
  currentDate,
}: HipChartProps) => {
  const yAxisConfig = data?.y_axis || { min: 50, max: 100 };
  const chartData = processSimpleTrackerChartData(
    data,
    selectedPeriod,
    currentDate
  );

  return (
    <BaseChart
      data={chartData}
      selectedPeriod={selectedPeriod}
      currentDate={currentDate}
      yAxisConfig={yAxisConfig}
      chartColor={getMetricColor("hip")}
      metricName="Hip Size"
      unit="cm"
    />
  );
};
